module.exports = __webpack_public_path__ + "img/cajaChica.392470ec.png";